import {
  Alert,
  Box,
  Typography,
  Button,
  Card,
  CardHeader,
  CardActions,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { getInfo } from '../api/scan-tool.api';
import StartRoundedIcon from '@mui/icons-material/StartRounded';
import { useNavigate } from 'react-router-dom';
import lang from '../i18n/lang';
import { ScansubmoduleDto } from '../dtos/participantdata/scanmodule/scansubmodule.dto';

const style = {
  marginTop: '3.5em',
  position: 'absolute',
  top: '5%',
  left: '5%',
  width: '100%',
};

function ModuleSelect({ token }: { token: string }) {
  const navigate = useNavigate();
  const [scanModules, setScanModules] = useState<ScansubmoduleDto[]>([]);
  const [eventName, setEventName] = useState('');
  const [userName, setUserName] = useState('');
  const getScanModules = async () => {
    const response = await getInfo(token);
    setScanModules(response.scansubmodules);
    setEventName(response.eventName);
    setUserName(response.userName);
  };

  useEffect(() => {
    getScanModules();
  }, []);
  const navigateToScanModule = (selectedModuleId: string) => {
    navigate(`/${selectedModuleId}`);
  };

  return (
    <Box sx={style}>
      <Typography align="left" variant="h3" sx={{ color: '#00537D' }}>
        {`${lang('scan.module.select')} ${eventName} - ${userName}`}
      </Typography>
      {scanModules.length === 0 ? (
        <Alert severity="info" sx={{ width: '60ch' }}>
          {lang('scan.module.none')}
        </Alert>
      ) : (
        <Box display="flex" flexDirection="row">
          {scanModules.map((scanModule: ScansubmoduleDto) => (
            <Card
              key={scanModule.id}
              elevation={5}
              sx={{ width: 300, m: 3, p: 1 }}
            >
              <CardHeader title={scanModule.name} />
              <CardActions>
                <Button
                  variant="outlined"
                  onClick={() => navigateToScanModule(scanModule.id)}
                  endIcon={<StartRoundedIcon />}
                >
                  {lang('scan.module.go')}
                </Button>
              </CardActions>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default ModuleSelect;
